export default {
  CONTROLS: 'controls',
  PHRASES: 'phrases',
  UNITS: 'units',
  TRANSLATIONS: 'translations',
};
